export const getLocalizedAppStoreUrl = (url: string, language: string): string => {
    if (!url.startsWith('https://apps.apple.com')) {
        return url;
    }

    try {
        const urlObj = new URL(url);
        const pathSegments = urlObj.pathname.split('/').filter(Boolean);

        // Check if first segment is a country code (2 letters)
        const hasCountryCode = pathSegments.length > 0 && /^[a-z]{2}$/.test(pathSegments[0]);
        const isJapanese = language.startsWith('ja');

        if (isJapanese) {
            if (hasCountryCode) {
                // Replace existing country code with 'jp'
                pathSegments[0] = 'jp';
            } else {
                // Insert 'jp' at the beginning
                pathSegments.unshift('jp');
            }
        } else {
            // For non-Japanese, remove 'jp' if it exists to revert to default/auto behavior
            // We don't force 'us' or others to allow Apple's smart redirection based on user account
            if (hasCountryCode && pathSegments[0] === 'jp') {
                pathSegments.shift();
            }
        }

        urlObj.pathname = '/' + pathSegments.join('/');
        return urlObj.toString();
    } catch (e) {
        console.error('Invalid URL:', url);
        return url;
    }
};
